import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { PLATFORM_ID, inject } from '@angular/core';
import { BrowserStorageService } from '@core/services/browser-storage/browser-storage.service';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const browserStorageService = inject(BrowserStorageService);
  const authenticationService = inject(AuthenticationService);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  if (isBrowser) {
    // Priority: backend configuration > localStorage > default
    // Directly read the signal value (no computed needed in interceptor)
    const user = authenticationService.currentUser();
    const currentLanguage =
      user?.configuration?.language || browserStorageService.get('currentLang') || 'ar';

    req = req.clone({
      setHeaders: {
        'Accept-Language': currentLanguage,
        'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        // 'ngrok-skip-browser-warning': 'true',
      },
    });
  } else {
    // Server/prerender: there is no real visitor context to read a preference from, so
    // requests would otherwise go out with no Accept-Language header at all - and the
    // backend's own no-header default has been observed to vary per record. Pin it to the
    // app's documented default so prerendered (crawler-visible) content is deterministic.
    req = req.clone({
      setHeaders: {
        'Accept-Language': 'ar',
      },
    });
  }
  return next(req);
};
